import { render, staticRenderFns } from "./SocialCustomField.vue?vue&type=template&id=079ae61e&"
import script from "./SocialCustomField.vue?vue&type=script&lang=js&"
export * from "./SocialCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports